export const BOOKING_TYPE_AIRPORT_TRANSFER = 'airport_transfer';
export const BOOKING_TYPE_CHAUFFEUR_SERVICES = 'chauffeur_services';
export const BOOKING_TYPE_CAR_RENTALS = 'car_rentals';
export const BOOKING_TYPE_RETURN_TRANSFER ='return_transfer';
export const BOOKING_TYPE_DEPARTURE_TRANSFER ='departure_transfer';

export const countryNames = [
    {
      code: 'AF',
      name: 'Afghanistan',
    },
    {
      code: 'AX',
      name: 'Aland Islands',
    },
    {
      code: 'AL',
      name: 'Albania',
    },
    {
      code: 'DZ',
      name: 'Algeria',
    },
    {
      code: 'AS',
      name: 'American Samoa',
    },
    {
      code: 'AD',
      name: 'Andorra',
    },
    {
      code: 'AO',
      name: 'Angola',
    },
    {
      code: 'AI',
      name: 'Anguilla',
    },
    {
      code: 'AQ',
      name: 'Antarctica',
    },
    {
      code: 'AG',
      name: 'Antigua And Barbuda',
    },
    {
      code: 'AR',
      name: 'Argentina',
    },
    {
      code: 'AM',
      name: 'Armenia',
    },
    {
      code: 'AW',
      name: 'Aruba',
    },
    {
      code: 'AU',
      name: 'Australia',
    },
    {
      code: 'AT',
      name: 'Austria',
    },
    {
      code: 'AZ',
      name: 'Azerbaijan',
    },
    {
      code: 'BS',
      name: 'Bahamas',
    },
    {
      code: 'BH',
      name: 'Bahrain',
    },
    {
      code: 'BD',
      name: 'Bangladesh',
    },
    {
      code: 'BB',
      name: 'Barbados',
    },
    {
      code: 'BY',
      name: 'Belarus',
    },
    {
      code: 'BE',
      name: 'Belgium',
    },
    {
      code: 'BZ',
      name: 'Belize',
    },
    {
      code: 'BJ',
      name: 'Benin',
    },
    {
      code: 'BM',
      name: 'Bermuda',
    },
    {
      code: 'BT',
      name: 'Bhutan',
    },
    {
      code: 'BO',
      name: 'Bolivia',
    },
    {
      code: 'BA',
      name: 'Bosnia And Herzegovina',
    },
    {
      code: 'BW',
      name: 'Botswana',
    },
    {
      code: 'BV',
      name: 'Bouvet Island',
    },
    {
      code: 'BR',
      name: 'Brazil',
    },
    {
      code: 'IO',
      name: 'British Indian Ocean Territory',
    },
    {
      code: 'BN',
      name: 'Brunei Darussalam',
    },
    {
      code: 'BG',
      name: 'Bulgaria',
    },
    {
      code: 'BF',
      name: 'Burkina Faso',
    },
    {
      code: 'BI',
      name: 'Burundi',
    },
    {
      code: 'KH',
      name: 'Cambodia',
    },
    {
      code: 'CM',
      name: 'Cameroon',
    },
    {
      code: 'CA',
      name: 'Canada',
    },
    {
      code: 'CV',
      name: 'Cape Verde',
    },
    {
      code: 'KY',
      name: 'Cayman Islands',
    },
    {
      code: 'CF',
      name: 'Central African Republic',
    },
    {
      code: 'TD',
      name: 'Chad',
    },
    {
      code: 'CL',
      name: 'Chile',
    },
    {
      code: 'CN',
      name: 'China',
    },
    {
      code: 'CX',
      name: 'Christmas Island',
    },
    {
      code: 'CC',
      name: 'Cocos (Keeling) Islands',
    },
    {
      code: 'CO',
      name: 'Colombia',
    },
    {
      code: 'KM',
      name: 'Comoros',
    },
    {
      code: 'CG',
      name: 'Congo',
    },
    {
      code: 'CD',
      name: 'Congo, Democratic Republic',
    },
    {
      code: 'CK',
      name: 'Cook Islands',
    },
    {
      code: 'CR',
      name: 'Costa Rica',
    },
    {
      code: 'CI',
      name: 'Cote D"Ivoire',
    },
    {
      code: 'HR',
      name: 'Croatia',
    },
    {
      code: 'CU',
      name: 'Cuba',
    },
    {
      code: 'CY',
      name: 'Cyprus',
    },
    {
      code: 'CZ',
      name: 'Czech Republic',
    },
    {
      code: 'DK',
      name: 'Denmark',
    },
    {
      code: 'DJ',
      name: 'Djibouti',
    },
    {
      code: 'DM',
      name: 'Dominica',
    },
    {
      code: 'DO',
      name: 'Dominican Republic',
    },
    {
      code: 'EC',
      name: 'Ecuador',
    },
    {
      code: 'EG',
      name: 'Egypt',
    },
    {
      code: 'SV',
      name: 'El Salvador',
    },
    {
      code: 'GQ',
      name: 'Equatorial Guinea',
    },
    {
      code: 'ER',
      name: 'Eritrea',
    },
    {
      code: 'EE',
      name: 'Estonia',
    },
    {
      code: 'ET',
      name: 'Ethiopia',
    },
    {
      code: 'FK',
      name: 'Falkland Islands (Malvinas)',
    },
    {
      code: 'FO',
      name: 'Faroe Islands',
    },
    {
      code: 'FJ',
      name: 'Fiji',
    },
    {
      code: 'FI',
      name: 'Finland',
    },
    {
      code: 'FR',
      name: 'France',
    },
    {
      code: 'GF',
      name: 'French Guiana',
    },
    {
      code: 'PF',
      name: 'French Polynesia',
    },
    {
      code: 'TF',
      name: 'French Southern Territories',
    },
    {
      code: 'GA',
      name: 'Gabon',
    },
    {
      code: 'GM',
      name: 'Gambia',
    },
    {
      code: 'GE',
      name: 'Georgia',
    },
    {
      code: 'DE',
      name: 'Germany',
    },
    {
      code: 'GH',
      name: 'Ghana',
    },
    {
      code: 'GI',
      name: 'Gibraltar',
    },
    {
      code: 'GR',
      name: 'Greece',
    },
    {
      code: 'GL',
      name: 'Greenland',
    },
    {
      code: 'GD',
      name: 'Grenada',
    },
    {
      code: 'GP',
      name: 'Guadeloupe',
    },
    {
      code: 'GU',
      name: 'Guam',
    },
    {
      code: 'GT',
      name: 'Guatemala',
    },
    {
      code: 'GG',
      name: 'Guernsey',
    },
    {
      code: 'GN',
      name: 'Guinea',
    },
    {
      code: 'GW',
      name: 'Guinea-Bissau',
    },
    {
      code: 'GY',
      name: 'Guyana',
    },
    {
      code: 'HT',
      name: 'Haiti',
    },
    {
      code: 'HM',
      name: 'Heard Island & Mcdonald Islands',
    },
    {
      code: 'VA',
      name: 'Holy See (Vatican City State)',
    },
    {
      code: 'HN',
      name: 'Honduras',
    },
    {
      code: 'HK',
      name: 'Hong Kong',
    },
    {
      code: 'HU',
      name: 'Hungary',
    },
    {
      code: 'IS',
      name: 'Iceland',
    },
    {
      code: 'IN',
      name: 'India',
    },
    {
      code: 'ID',
      name: 'Indonesia',
    },
    {
      code: 'IR',
      name: 'Iran, Islamic Republic Of',
    },
    {
      code: 'IQ',
      name: 'Iraq',
    },
    {
      code: 'IE',
      name: 'Ireland',
    },
    {
      code: 'IM',
      name: 'Isle Of Man',
    },
    {
      code: 'IL',
      name: 'Israel',
    },
    {
      code: 'IT',
      name: 'Italy',
    },
    {
      code: 'JM',
      name: 'Jamaica',
    },
    {
      code: 'JP',
      name: 'Japan',
    },
    {
      code: 'JE',
      name: 'Jersey',
    },
    {
      code: 'JO',
      name: 'Jordan',
    },
    {
      code: 'KZ',
      name: 'Kazakhstan',
    },
    {
      code: 'KE',
      name: 'Kenya',
    },
    {
      code: 'KI',
      name: 'Kiribati',
    },
    {
      code: 'KR',
      name: 'Korea',
    },
    {
      code: 'KP',
      name: 'North Korea',
    },
    {
      code: 'KW',
      name: 'Kuwait',
    },
    {
      code: 'KG',
      name: 'Kyrgyzstan',
    },
    {
      code: 'LA',
      name: 'Lao People"s Democratic Republic',
    },
    {
      code: 'LV',
      name: 'Latvia',
    },
    {
      code: 'LB',
      name: 'Lebanon',
    },
    {
      code: 'LS',
      name: 'Lesotho',
    },
    {
      code: 'LR',
      name: 'Liberia',
    },
    {
      code: 'LY',
      name: 'Libyan Arab Jamahiriya',
    },
    {
      code: 'LI',
      name: 'Liechtenstein',
    },
    {
      code: 'LT',
      name: 'Lithuania',
    },
    {
      code: 'LU',
      name: 'Luxembourg',
    },
    {
      code: 'MO',
      name: 'Macao',
    },
    {
      code: 'MK',
      name: 'Macedonia',
    },
    {
      code: 'MG',
      name: 'Madagascar',
    },
    {
      code: 'MW',
      name: 'Malawi',
    },
    {
      code: 'MY',
      name: 'Malaysia',
    },
    {
      code: 'MV',
      name: 'Maldives',
    },
    {
      code: 'ML',
      name: 'Mali',
    },
    {
      code: 'MT',
      name: 'Malta',
    },
    {
      code: 'MH',
      name: 'Marshall Islands',
    },
    {
      code: 'MQ',
      name: 'Martinique',
    },
    {
      code: 'MR',
      name: 'Mauritania',
    },
    {
      code: 'MU',
      name: 'Mauritius',
    },
    {
      code: 'YT',
      name: 'Mayotte',
    },
    {
      code: 'MX',
      name: 'Mexico',
    },
    {
      code: 'FM',
      name: 'Micronesia, Federated States Of',
    },
    {
      code: 'MD',
      name: 'Moldova',
    },
    {
      code: 'MC',
      name: 'Monaco',
    },
    {
      code: 'MN',
      name: 'Mongolia',
    },
    {
      code: 'ME',
      name: 'Montenegro',
    },
    {
      code: 'MS',
      name: 'Montserrat',
    },
    {
      code: 'MA',
      name: 'Morocco',
    },
    {
      code: 'MZ',
      name: 'Mozambique',
    },
    {
      code: 'MM',
      name: 'Myanmar',
    },
    {
      code: 'NA',
      name: 'Namibia',
    },
    {
      code: 'NR',
      name: 'Nauru',
    },
    {
      code: 'NP',
      name: 'Nepal',
    },
    {
      code: 'NL',
      name: 'Netherlands',
    },
    {
      code: 'AN',
      name: 'Netherlands Antilles',
    },
    {
      code: 'NC',
      name: 'New Caledonia',
    },
    {
      code: 'NZ',
      name: 'New Zealand',
    },
    {
      code: 'NI',
      name: 'Nicaragua',
    },
    {
      code: 'NE',
      name: 'Niger',
    },
    {
      code: 'NG',
      name: 'Nigeria',
    },
    {
      code: 'NU',
      name: 'Niue',
    },
    {
      code: 'NF',
      name: 'Norfolk Island',
    },
    {
      code: 'MP',
      name: 'Northern Mariana Islands',
    },
    {
      code: 'NO',
      name: 'Norway',
    },
    {
      code: 'OM',
      name: 'Oman',
    },
    {
      code: 'PK',
      name: 'Pakistan',
    },
    {
      code: 'PW',
      name: 'Palau',
    },
    {
      code: 'PS',
      name: 'Palestinian Territory, Occupied',
    },
    {
      code: 'PA',
      name: 'Panama',
    },
    {
      code: 'PG',
      name: 'Papua New Guinea',
    },
    {
      code: 'PY',
      name: 'Paraguay',
    },
    {
      code: 'PE',
      name: 'Peru',
    },
    {
      code: 'PH',
      name: 'Philippines',
    },
    {
      code: 'PN',
      name: 'Pitcairn',
    },
    {
      code: 'PL',
      name: 'Poland',
    },
    {
      code: 'PT',
      name: 'Portugal',
    },
    {
      code: 'PR',
      name: 'Puerto Rico',
    },
    {
      code: 'QA',
      name: 'Qatar',
    },
    {
      code: 'RE',
      name: 'Reunion',
    },
    {
      code: 'RO',
      name: 'Romania',
    },
    {
      code: 'RU',
      name: 'Russian Federation',
    },
    {
      code: 'RW',
      name: 'Rwanda',
    },
    {
      code: 'BL',
      name: 'Saint Barthelemy',
    },
    {
      code: 'SH',
      name: 'Saint Helena',
    },
    {
      code: 'KN',
      name: 'Saint Kitts And Nevis',
    },
    {
      code: 'LC',
      name: 'Saint Lucia',
    },
    {
      code: 'MF',
      name: 'Saint Martin',
    },
    {
      code: 'PM',
      name: 'Saint Pierre And Miquelon',
    },
    {
      code: 'VC',
      name: 'Saint Vincent And Grenadines',
    },
    {
      code: 'WS',
      name: 'Samoa',
    },
    {
      code: 'SM',
      name: 'San Marino',
    },
    {
      code: 'ST',
      name: 'Sao Tome And Principe',
    },
    {
      code: 'SA',
      name: 'Saudi Arabia',
    },
    {
      code: 'SN',
      name: 'Senegal',
    },
    {
      code: 'RS',
      name: 'Serbia',
    },
    {
      code: 'SC',
      name: 'Seychelles',
    },
    {
      code: 'SL',
      name: 'Sierra Leone',
    },
    {
      code: 'SG',
      name: 'Singapore',
    },
    {
      code: 'SK',
      name: 'Slovakia',
    },
    {
      code: 'SI',
      name: 'Slovenia',
    },
    {
      code: 'SB',
      name: 'Solomon Islands',
    },
    {
      code: 'SO',
      name: 'Somalia',
    },
    {
      code: 'ZA',
      name: 'South Africa',
    },
    {
      code: 'GS',
      name: 'South Georgia And Sandwich Isl.',
    },
    {
      code: 'ES',
      name: 'Spain',
    },
    {
      code: 'LK',
      name: 'Sri Lanka',
    },
    {
      code: 'SD',
      name: 'Sudan',
    },
    {
      code: 'SR',
      name: 'Suriname',
    },
    {
      code: 'SJ',
      name: 'Svalbard And Jan Mayen',
    },
    {
      code: 'SZ',
      name: 'Swaziland',
    },
    {
      code: 'SE',
      name: 'Sweden',
    },
    {
      code: 'CH',
      name: 'Switzerland',
    },
    {
      code: 'SY',
      name: 'Syrian Arab Republic',
    },
    {
      code: 'TW',
      name: 'Taiwan',
    },
    {
      code: 'TJ',
      name: 'Tajikistan',
    },
    {
      code: 'TZ',
      name: 'Tanzania',
    },
    {
      code: 'TH',
      name: 'Thailand',
    },
    {
      code: 'TL',
      name: 'Timor-Leste',
    },
    {
      code: 'TG',
      name: 'Togo',
    },
    {
      code: 'TK',
      name: 'Tokelau',
    },
    {
      code: 'TO',
      name: 'Tonga',
    },
    {
      code: 'TT',
      name: 'Trinidad And Tobago',
    },
    {
      code: 'TN',
      name: 'Tunisia',
    },
    {
      code: 'TR',
      name: 'Turkey',
    },
    {
      code: 'TM',
      name: 'Turkmenistan',
    },
    {
      code: 'TC',
      name: 'Turks And Caicos Islands',
    },
    {
      code: 'TV',
      name: 'Tuvalu',
    },
    {
      code: 'UG',
      name: 'Uganda',
    },
    {
      code: 'UA',
      name: 'Ukraine',
    },
    {
      code: 'AE',
      name: 'United Arab Emirates',
    },
    {
      code: 'GB',
      name: 'United Kingdom',
    },
    {
      code: 'US',
      name: 'United States',
    },
    {
      code: 'UM',
      name: 'United States Outlying Islands',
    },
    {
      code: 'UY',
      name: 'Uruguay',
    },
    {
      code: 'UZ',
      name: 'Uzbekistan',
    },
    {
      code: 'VU',
      name: 'Vanuatu',
    },
    {
      code: 'VE',
      name: 'Venezuela',
    },
    {
      code: 'VN',
      name: 'Vietnam',
    },
    {
      code: 'VG',
      name: 'Virgin Islands, British',
    },
    {
      code: 'VI',
      name: 'Virgin Islands, U.S.',
    },
    {
      code: 'WF',
      name: 'Wallis And Futuna',
    },
    {
      code: 'EH',
      name: 'Western Sahara',
    },
    {
      code: 'YE',
      name: 'Yemen',
    },
    {
      code: 'ZM',
      name: 'Zambia',
    },
    {
      code: 'ZW',
      name: 'Zimbabwe',
    },
]

export const getPlaceDetailsByTextSearch = async (location) => {
    try {
      const response = await fetch(`https://staging.rolzo.com/api/api/v1/GeoPlaceDetailsByTextSearch?location=${location}`);
      const result = await response.json();
      return result;
    } catch (error) {
        console.error('Error getPlaceDetailsByTextSearch:', error);
        return null;
    }
}

export const createNewPartner = async (payload) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/v1/partner/registration/createUser`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error createNewPartner:', error);
    return null;
  }
};


export const defaultFleetOptions = [
  { value: '1-5 vehicles', label: '1-5 vehicles' },
  { value: '5-15 vehicles', label: '5-15 vehicles' },
  { value: '15-25 vehicles', label: '15-25 vehicles' },
  { value: '25-50 vehicles', label: '25-50 vehicles' },
  { value: '50+ vehicles', label: '50+ vehicles' },
]

export const defaultCurrencies = [
  { label: 'GBP', value: 'currency_gbp' },
  { label: 'EUR', value: 'currency_eur' },
  { label: 'USD', value: 'currency_usd' },
  { label: 'AED', value: 'currency_aed' },
  { label: 'AFN', value: 'currency_afn' },
  { label: 'ALL', value: 'currency_all' },
  { label: 'AMD', value: 'currency_amd' },
  { label: 'ANG', value: 'currency_ang' },
  { label: 'AOA', value: 'currency_aoa' },
  { label: 'ARS', value: 'currency_ars' },
  { label: 'AUD', value: 'currency_aud' },
  { label: 'AWG', value: 'currency_awg' },
  { label: 'AZN', value: 'currency_azn' },
  { label: 'BAM', value: 'currency_bam' },
  { label: 'BBD', value: 'currency_bbd' },
  { label: 'BDT', value: 'currency_bdt' },
  { label: 'BGN', value: 'currency_bgn' },
  { label: 'BHD', value: 'currency_bhd' },
  { label: 'BIF', value: 'currency_bif' },
  { label: 'BMD', value: 'currency_bmd' },
  { label: 'BND', value: 'currency_bnd' },
  { label: 'BOB', value: 'currency_bob' },
  { label: 'BRL', value: 'currency_brl' },
  { label: 'BSD', value: 'currency_bsd' },
  { label: 'BWP', value: 'currency_bwp' },
  { label: 'BZD', value: 'currency_bzd' },
  { label: 'CAD', value: 'currency_cad' },
  { label: 'CDF', value: 'currency_cdf' },
  { label: 'CHF', value: 'currency_chf' },
  { label: 'CLP', value: 'currency_clp' },
  { label: 'CNY', value: 'currency_cny' },
  { label: 'COP', value: 'currency_cop' },
  { label: 'CRC', value: 'currency_crc' },
  { label: 'CVE', value: 'currency_cve' },
  { label: 'CZK', value: 'currency_czk' },
  { label: 'DJF', value: 'currency_djf' },
  { label: 'DKK', value: 'currency_dkk' },
  { label: 'DOP', value: 'currency_dop' },
  { label: 'DZD', value: 'currency_dzd' },
  { label: 'EGP', value: 'currency_egp' },
  { label: 'ETB', value: 'currency_etb' },
  { label: 'FJD', value: 'currency_fjd' },
  { label: 'FKP', value: 'currency_fkp' },
  { label: 'GEL', value: 'currency_gel' },
  { label: 'GIP', value: 'currency_gip' },
  { label: 'GMD', value: 'currency_gmd' },
  { label: 'GNF', value: 'currency_gnf' },
  { label: 'GTQ', value: 'currency_gtq' },
  { label: 'GYD', value: 'currency_gyd' },
  { label: 'HKD', value: 'currency_hkd' },
  { label: 'HNL', value: 'currency_hnl' },
  { label: 'HRK', value: 'currency_hrk' },
  { label: 'HTG', value: 'currency_htg' },
  { label: 'HUF', value: 'currency_huf' },
  { label: 'IDR', value: 'currency_idr' },
  { label: 'ILS', value: 'currency_ils' },
  { label: 'INR', value: 'currency_inr' },
  { label: 'ISK', value: 'currency_isk' },
  { label: 'JMD', value: 'currency_jmd' },
  { label: 'JPY', value: 'currency_jpy' },
  { label: 'KES', value: 'currency_kes' },
  { label: 'KGS', value: 'currency_kgs' },
  { label: 'KHR', value: 'currency_khr' },
  { label: 'KMF', value: 'currency_kmf' },
  { label: 'KRW', value: 'currency_krw' },
  { label: 'KWD', value: 'currency_kwd' },
  { label: 'KYD', value: 'currency_kyd' },
  { label: 'KZT', value: 'currency_kzt' },
  { label: 'LAK', value: 'currency_lak' },
  { label: 'LBP', value: 'currency_lbp' },
  { label: 'LKR', value: 'currency_lkr' },
  { label: 'LRD', value: 'currency_lrd' },
  { label: 'LSL', value: 'currency_lsl' },
  { label: 'MAD', value: 'currency_mad' },
  { label: 'MDL', value: 'currency_mdl' },
  { label: 'MGA', value: 'currency_mga' },
  { label: 'MKD', value: 'currency_mkd' },
  { label: 'MNT', value: 'currency_mnt' },
  { label: 'MOP', value: 'currency_mop' },
  { label: 'MRO', value: 'currency_mro' },
  { label: 'MUR', value: 'currency_mur' },
  { label: 'MVR', value: 'currency_mvr' },
  { label: 'MWK', value: 'currency_mwk' },
  { label: 'MXN', value: 'currency_mxn' },
  { label: 'MYR', value: 'currency_myr' },
  { label: 'MZN', value: 'currency_mzn' },
  { label: 'NAD', value: 'currency_nad' },
  { label: 'NGN', value: 'currency_ngn' },
  { label: 'NIO', value: 'currency_nio' },
  { label: 'NOK', value: 'currency_nok' },
  { label: 'NPR', value: 'currency_npr' },
  { label: 'NZD', value: 'currency_nzd' },
  { label: 'OMR', value: 'currency_omr' },
  { label: 'PAB', value: 'currency_pab' },
  { label: 'PEN', value: 'currency_pen' },
  { label: 'PGK', value: 'currency_pgk' },
  { label: 'PHP', value: 'currency_php' },
  { label: 'PKR', value: 'currency_pkr' },
  { label: 'PLN', value: 'currency_pln' },
  { label: 'PYG', value: 'currency_pyg' },
  { label: 'QAR', value: 'currency_qar' },
  { label: 'RON', value: 'currency_ron' },
  { label: 'RSD', value: 'currency_rsd' },
  { label: 'RUB', value: 'currency_rub' },
  { label: 'RWF', value: 'currency_rwf' },
  { label: 'SAR', value: 'currency_sar' },
  { label: 'SBD', value: 'currency_sbd' },
  { label: 'SCR', value: 'currency_scr' },
  { label: 'SEK', value: 'currency_sek' },
  { label: 'SGD', value: 'currency_sgd' },
  { label: 'SHP', value: 'currency_shp' },
  { label: 'SLL', value: 'currency_sll' },
  { label: 'SOS', value: 'currency_sos' },
  { label: 'SRD', value: 'currency_srd' },
  { label: 'STD', value: 'currency_std' },
  { label: 'SVC', value: 'currency_svc' },
  { label: 'SZL', value: 'currency_szl' },
  { label: 'THB', value: 'currency_thb' },
  { label: 'TJS', value: 'currency_tjs' },
  { label: 'TOP', value: 'currency_top' },
  { label: 'TRY', value: 'currency_try' },
  { label: 'TTD', value: 'currency_ttd' },
  { label: 'TWD', value: 'currency_twd' },
  { label: 'TZS', value: 'currency_tzs' },
  { label: 'UAH', value: 'currency_uah' },
  { label: 'UGX', value: 'currency_ugx' },
  { label: 'UYU', value: 'currency_uyu' },
  { label: 'UZS', value: 'currency_uzs' },
  { label: 'VND', value: 'currency_vnd' },
  { label: 'VUV', value: 'currency_vuv' },
  { label: 'WST', value: 'currency_wst' },
  { label: 'XAF', value: 'currency_xaf' },
  { label: 'XCD', value: 'currency_xcd' },
  { label: 'XOF', value: 'currency_xof' },
  { label: 'XPD', value: 'currency_xpd' },
  { label: 'XPF', value: 'currency_xpf' },
  { label: 'YER', value: 'currency_yer' },
  { label: 'ZAR', value: 'currency_zar' },
  { label: 'ZMW', value: 'currency_zmw' },
]

export const europeanCountriesCodes = [
  'AL',
  'AD',
  'AM',
  'AT',
  'AZ',
  'BY',
  'BE',
  'BA',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FO',
  'FI',
  'FR',
  'GE',
  'DE',
  'GI',
  'GR',
  'HU',
  'IS',
  'IE',
  'IT',
  'KZ',
  'XK',
  'LV',
  'LI',
  'LT',
  'LU',
  'MT',
  'MD',
  'MC',
  'ME',
  'NL',
  'MK',
  'NO',
  'PL',
  'PT',
  'RO',
  'RU',
  'SM',
  'RS',
  'SK',
  'SI',
  'ES',
  'SJ',
  'SE',
  'CH',
  'TR',
  'UA',
  'GB',
  'VA',
]
  